import DatePicker from "./date-picker";

export default class Header {

	constructor() {
		const bookingOverlay = document.querySelector('.booking-overlay');
		const navigationOverlay = document.querySelector('.navigation-overlay');
		const backdrop = document.getElementById('header-backdrop');

		const openOverlay = (overlay) => {
			overlay.classList.add('active');
			backdrop.classList.add('active');
		};

		const closeAll = () => {
			bookingOverlay.classList.remove('active');
			navigationOverlay.classList.remove('active');
			backdrop.classList.remove('active');
		};

		document.querySelectorAll('.header-booking-toggle').forEach(btn => {
			btn.addEventListener('click', () => openOverlay(bookingOverlay));
		});

		document.getElementById('mobile-menu-btn')?.addEventListener('click', () => {
			openOverlay(navigationOverlay);
		});

		document.querySelectorAll('.header-overlay .close').forEach(btn => {
			btn.addEventListener('click', () => closeAll());
		});

		backdrop.addEventListener('click', () => closeAll());

		document.addEventListener('click', e => {
			if (!e.target.closest('.header-overlay') &&
					!e.target.closest('.header-booking-toggle') &&
					!e.target.closest('#mobile-menu-btn')) {
				closeAll();
			}
		});

		const header = document.getElementById('header');
		const spacer = document.createElement('div');
		header.after(spacer);

		const logo = header.querySelector('.logo');
		const logoHeight = logo.offsetHeight;
		let scrolled = false;
		const handleScroll = () => {
			if (window.scrollY < logoHeight) {
				if (scrolled) {
					header.classList.remove('is-sticky');
					scrolled = false;
				}
			} else {
				if (!scrolled) {
					header.classList.add('is-sticky');
					scrolled = true;
				}
			}
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		handleScroll();


		const headerUnderlay = document.querySelector('#header-underlay');
		if (headerUnderlay) {
			const resizeHeaderUnderlay = () => {
				headerUnderlay.style.height = header.offsetHeight + 'px';
			}
			window.addEventListener('resize', resizeHeaderUnderlay);
			resizeHeaderUnderlay();
		}



		const checkIn = document.getElementById('header-booking-form--check-in');
		const checkOut = document.getElementById('header-booking-form--check-out');
		new DatePicker(checkIn, checkOut);


		const form = document.getElementById('header-booking-form');
		const hotelSelect = document.getElementById('header-booking-form--hotel');
		hotelSelect.addEventListener('change', () => {
			form.action = hotelSelect.value;
		});

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			const base = form.action;
			if (!base) return;
			const arrive = document.getElementById('header-booking-form--check-in-submit').value;
			const depart = document.getElementById('header-booking-form--check-out-submit').value;
			const adults = document.getElementById('header-booking-form--guests').value;
			const params = new URLSearchParams({ arrive, depart, adults });
			window.location.href = `${base}?${params.toString()}`;
		});



	}
}
